import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EnvelopeOpenIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M22.5 9c-.55 0-1 .45-1 1v.78l-9 5.61-9-5.61V10c0-.55-.45-1-1-1s-1 .45-1 1v10.4c0 .69.29 1.37.8 1.85.5.48 1.17.75 1.87.75h16.67c.7 0 1.37-.27 1.87-.75.51-.49.8-1.16.8-1.85V10c0-.55-.45-1-1-1h-.01zm-1.18 11.81c-.13.12-.3.19-.49.19H4.17c-.18 0-.36-.07-.49-.19a.554.554 0 01-.18-.41v-7.26l8.47 5.28a1.014 1.014 0 001.06 0l8.47-5.28v7.26c0 .15-.06.3-.18.41z"
                        }),
                        _jsx("path", {
                            d: "M5.5 10c.55 0 1-.45 1-1V3.56c0-.15.06-.29.16-.39.11-.1.25-.16.39-.16h10.89c.15 0 .29.06.39.16.11.11.16.24.16.39V9c0 .55.45 1 1 1s1-.45 1-1V3.56c0-.68-.27-1.32-.75-1.81A2.54 2.54 0 0017.93 1H7.06c-.68 0-1.32.27-1.81.75a2.54 2.54 0 00-.75 1.81V9c0 .55.45 1 1 1z"
                        }),
                        _jsx("path", {
                            d: "M15.5 5h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm0 4h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"
                        })
                    ]
                })
            })
        ]
    });
};
EnvelopeOpenIcon.isCarinaIcon = true;
export default EnvelopeOpenIcon;
